export const APP_STATE_KEY = 'app';
export const NOTIFICATION_SOUND_FILE_URL = 'https://s3.amazonaws.com/static.acad.ly/new/notification.m4a';
